<div class="profile">
  <div class="image">
    <app-image [src]="url()" />
  </div>
  <div class="details">
    <p class="name">{{firstName()}} {{lastName()}}</p>
    <!--FEATURE-->
    <!-- <p class="edit">Edit profile image</p> -->
  </div>
</div>